/* istanbul ignore file */
import { isPlatform } from '@ionic/core';
import { FileEntry, File as IonFile } from '@ionic-native/file/ngx';
import { ObjectUrlService } from './../services/object-url/object-url.service';

const prefix = 'cdvfile://localhost/temporary/';

export const blobToFile = async (filename: string, blob: Blob, objectURLsvc?: ObjectUrlService): Promise<URLable> => {
  if (isPlatform('cordova')) {
    const fileObject = new IonFile();
    return (await fileObject.writeFile(prefix, filename, blob, { append: false, replace: true })) as FileEntry;
  }
  return new Promise<URLable>((resolve, reject) => {
    try {
      resolve({
        toURL: (): string => (objectURLsvc ? objectURLsvc.createObjectURL(blob) : window.URL.createObjectURL(blob)),
      });
    } catch (err) {
      reject('');
    }
  });
};

export const fileEntryToArrayBuffer = async (fileEntry: FileEntry) => {
  return new Promise<ArrayBuffer>((resolve, reject) =>
    fileEntry.file(file => {
      const fileReader = new FileReader();
      fileReader.onloadend = () => {
        resolve(fileReader.result as ArrayBuffer);
      };
      fileReader.onerror = () => reject(fileReader.error);
      fileReader.readAsArrayBuffer(file);
    }, reject)
  );
};

export const fileEntryToFile = async (fileEntry: FileEntry) => {
  return await new Promise((resolve, reject) => fileEntry.file(resolve, reject));
};

export const resolveFileSystemURL = async (url: string) => {
  return new Promise((resolve, reject) => (window as any).resolveLocalFileSystemURL(url, resolve, reject));
};

interface URLable {
  toURL: () => string;
}
